// Define light and dark colors
export const lightColours = {
  lightBlue: "#DDF2FE",
  lightBluePurple: "#DCE0FD",
  darkPurple: "#8E36EC",
  lightPurple: "#E9D2FE",
  purpleText: "#BC429E",
  lightGrey: "#EBEBEB",
  pink: "#EE8CD7",
  lightPink: "#F5C6EA",
  lightPink2: "#FCE8F9",
  darkBlue: "#34677A",
  midBlue: "#52ADD2",
  lightBlueTertiary: "#B2E2F4",
  appBar: "#ffffff",
  ctaButton: "#1A79C7",
  footer: "#222222",
  header: "#FFFFFF"
};

export const darkColours = {
  darkGrey: "#222222",
  lightGrey: "#3E3E3E",
  lightBlue: "#4EAED5",
  darkBlue: "#38687A",
  lightPink: "#EE8CD7",
  darkPink: "#87577D",
};